export default function (params: { [key: string]: any }): string {
  return Object.keys(params)
    .sort()
    .map((key) => {
      let value = params[key]
      value = value === null || value === undefined ? '' : value

      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    })
    .join('&')
}
